<template>
    <gm ref="gm" :geo="geo" :toggleNoDetects="geo.toggleNoDetects" :reset="reset" :height="height + 'px'" @loading="$emit('loading')" @loaded="$emit('loaded')"
        style="border-radius: 4px; overflow: hidden;">
    </gm>
</template>

<script>
    export default {
        components: {
            gm: () => import('./base/gm.vue'),
        },

        props: {
            geo: {
                required: false,
            },
            height: {
                type: Number,
                default: 300
            },
            reset: {
                type: Boolean,
                default: false,
            }
        },

        watch: {
            geo: {
                deep: true,
                handler() {
                    this.$nextTick(() => {
                        this.$refs.gm.refresh_map()
                    })
                }
            }
        },
    }

</script>